{/* QualitativeViolations Section */}
export const PaymentStatus = {
    ALL: { value: "", labelKey: "all-payments" },
    YES: { value: "true", labelKey: "paid" },
    NO: { value: "false", labelKey: "unpaid" },
};

export const PaymentType = {
    ALL: { value: "ALL", labelKey: "all-payment-types" },
    DETRAN: { value: "DETRAN", labelKey: "detran" },
    RADAR: { value: "RADAR", labelKey: "radar" },
    SNE: { value: "SNE", labelKey: "sne" },
};

export const ObservationType = {
    ALL: { value: "", labelKey: "all-observation-types" },
    VIDEOMONITORAMENTO: { value: "VIDEOMONITORAMENTO", labelKey: "videomonitoring" },
};

{/* Monthly Report Section */}
export const ReportStatuses = {
  VALIDATED: { value: "VALIDADA", labelKey: "valid" },
  CANCELED: { value: "CANCELADA", labelKey: "canceled" },
  DIVERGENT: { value: "DIVERGENTE", labelKey: "divergent" },
  AGENT_ERROR: { value: "ERRO_AGENTE", labelKey: "agent-error" },
  OTHERS: { value: "OUTROS", labelKey: "others" },
  WARNING: { value: "ADVERTENCIA", labelKey: "warning" },
  OTHER_STATES: { value: "OUTROS_ESTADOS", labelKey: "other-states" },
  NOT_REGISTERED: { value: "NAO_CADASTRADA", labelKey: "not-signed" },
  NOT_VALIDATED: { value: "NAO_VALIDADA", labelKey: "not-valid" },
  UNREADABLE: { value: "ILEGIVEL", labelKey: "unreadable" },
  DUPLICATED: { value: "DUPLICADA", labelKey: "duplicated" },
  ERRO_REG_EQUIP: { value: "ERRO_REG_EQUIPAMENTO", labelKey: "equipment-register-error" },
  VEHICLE_EMERGENCY: { value: "VEICULO_EMERGENCIA_URGENCIA", labelKey: "emergency-vehicle" },
};

export const MonthlyReportType = {
    QUANTITATIVE_INFRACTIONS_AGENTS_MONTH: {
        url: 'quantitativo-infracoes-agentes-mes',
        title: 'reports.violations-by-agent.title',
        description: 'reports.violations-by-agent.description'
    },
    QUANTITATIVE_INFRACTIONS_EQUIPMENT_MONTH: {
        url: 'quantitativo-infracoes-equipamentos-mes',
        title: 'reports.violations-by-equipment.title',
        description: 'reports.violations-by-equipment.description'
    },
    QUANTITATIVE_INFRACTIONS_TYPES_MONTH: {
        url: 'quantitativo-infracoes-tipos-mes',
        title: 'reports.violations-by-type.title',
        description: 'reports.violations-by-type.description'
    },
    SUMMARY_VALUES_INFRACTIONS: {
        url: 'resumo-valores-infracoes',
        title: 'reports.fines-summary.title',
        description: 'reports.fines-summary.description'
    },
    VALUES_INFRACTIONS_TO_BE_RECEIVED_MONTH: {
        url: 'valores-infracoes-a-receber-mes',
        title: 'reports.fines-to-receive-monthly.title',
        description: 'reports.fines-to-receive-monthly.description'
    },
    QUANTITATIVE_PERMITTEES_DOCUMENTS_MONTH: {
        url: 'quantitativo-documentos-permissionarios-mes',
        title: 'reports.permittees-documents-monthly.title',
        description: 'reports.permittees-documents-monthly.description'
    },
}

{/* Managerial Section */}
export const CREATED = "created";
export const ACCEPTED = "deferred";
export const REJECTED = "rejected";

export const STATUS_MAP = {
  CRIADA: CREATED,
  DEFERIDA: ACCEPTED,
  INDEFERIDA: REJECTED,
};

export const PROCESS_TYPES = {
    ic: "IC",
    na: "NA",
    np: "NP",
    re: "REEMBOLSO",
    ce: "CETRAN",
    ad: "ADVERTÊNCIA",
};

export const STATUS_COLORS = {
  [CREATED]: "#edc240",
  [ACCEPTED]: "#afd8f8",
  [REJECTED]: "#cb4b4b",
};

export const STATUS_LABEL_KEYS = {
  [CREATED]: "reports.managerial.process-status.created",
  [ACCEPTED]: "reports.managerial.process-status.deferred",
  [REJECTED]: "reports.managerial.process-status.rejected",
};

export const CHARTS_CONFIGS = {
  line: {
    mode: "lines+markers",
    marker: { size: 10 },
    line: { width: 3, },
  },
  layout: {
    margin: { t: 20, r: 20, b: 40, l: 40 },
    legend: { orientation: "h", y: -0.2 },
    xaxis: { automargin: true },
    yaxis: { automargin: true },
  },
};